import create from 'zustand';

type Company = 'rcycle' | 'reifenhauser' | 'comexi' | undefined;

interface BrandStore {
    companyName: Company;
    saveCompanyName: (company: Company) => void;
    themes: any;
}

const useBrandStore = create<BrandStore>((set) => ({
    companyName: undefined,
    saveCompanyName: (company) => set({ companyName: company }),
    themes: {
        rcycle: {
            'clr-beta-1': '#eef4f4',
            'clr-beta-2': '#00906a',
            'clr-beta-3': '#013a98',
            'header-body':
                'linear-gradient(150deg, var(--clr-beta-3), var(--clr-beta-2))',
            heading:
                'linear-gradient(150deg, var(--clr-beta-2), var(--clr-beta-3))',
            'heading-inverted':
                'linear-gradient(150deg, var(--clr-beta-3), var(--clr-beta-2))',
        },
        comexi: {
            'clr-beta-1': '#ECEEF2',
            'clr-beta-2': '#455560',
            'clr-beta-3': '#ED1849',
            'ff-primary': '"Open Sans"',
            'header-body': 'var(--clr-beta-3)',
            heading: 'var(--clr-beta-3)',
            'heading-inverted': 'var(--clr-beta-3)',
        },
        reifenhauser: {
            'clr-beta-1': '#E5EAEA',
            'clr-beta-2': '#013A98',
            'clr-beta-3': '#0787D1',
            'header-body': 'var(--clr-beta-3)',
            heading: 'var(--clr-beta-3)',
            'heading-inverted': 'var(--clr-beta-3)',
        },
    },
}));

export default useBrandStore;
